/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TPrebookOfferModel,
  IPrebookOfferRequest,
  IMappers,
  IPrebookOfferResponse,
  IPrebookOfferResponseError,
  TPrebookOfferResponse,
} from './types';

const defaultConfig: TPrebookOfferModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'profitbase-booking',
  pathApi: '/v1/prebook-offer/',
  hostType: 'api',
} as TPrebookOfferModel;

function createPrebookOfferModel(parameters: IPrebookOfferRequest): TPrebookOfferModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPrebookOfferOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IPrebookOfferRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchPrebookOffer<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IPrebookOfferOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TPrebookOfferResponse> {
  const { response, statusCode } = await httpApi.fetch(createPrebookOfferModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPrebookOfferResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IPrebookOfferResponseError);
    }
  }

  return { response, statusCode } as TPrebookOfferResponse;
}

export { defaultConfig, createPrebookOfferModel, fetchPrebookOffer };
